var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "tit": "교육 서비스",
      "titBtn": "",
      "topBtn": "",
      "fullHeight": ""
    }
  }, [_c('template', {
    slot: "titBtn"
  }, [_c('lecture-list-help', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticStyle: {
            "display": "inline-flex"
          },
          attrs: {
            "text": "",
            "icon": "",
            "x-large": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "x-large": ""
          }
        }, [_vm._v("mdi-help-circle-outline")])], 1)];
      }
    }])
  })], 1), _c('template', {
    slot: "topBtn"
  }, [_c('lecture-form', _vm._g({
    on: {
      "input": _vm.updateItem
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary"
          }
        }, 'v-btn', Object.assign({}, attrs, {
          loading: _vm.loading
        }), false), on), [_c('span', [_vm._v(" 영상 등록하기 ")])])];
      }
    }])
  }, {
    search: _vm.search
  }))], 1), _c('template', {
    slot: "contents"
  }, [_vm.items.length ? [_c('div', {
    staticClass: "v-cards"
  }, [_c('v-row', [_vm._l(_vm.items, function (value) {
    return [_c('v-col', {
      key: value._id,
      attrs: {
        "cols": "6",
        "lg": "4"
      }
    }, [_c('lecture-list-item', _vm._g(_vm._b({}, 'lecture-list-item', {
      value: value,
      loading: _vm.loading
    }, false), {
      search: _vm.search,
      remove: _vm.remove
    }))], 1)];
  })], 2)], 1), _c('v-pagination', {
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page: page
          })
        });
      }
    }
  })] : [_c('v-layout', {
    staticClass: "w-100 h-100 grey-f7 rounded-lg pa-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--lg line-height-15 text-center mb-12 mb-lg-32"
  }, [_vm._v(" 안녕하세요, 담당자님. "), _c('br'), _vm._v(" 등록된 영상이 없습니다. ")]), _c('lecture-form', _vm._g({
    on: {
      "input": _vm.updateItem
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var attrs = _ref3.attrs,
          on = _ref3.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "v-btn--column",
          attrs: {
            "text": "",
            "height": "auto",
            "color": "transparent"
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "icon icon-plus-lg"
        }), _c('span', {
          staticClass: "mt-6 mt-lg-14 grey-9--text"
        }, [_vm._v("영상 등록하기")])])];
      }
    }])
  }, {
    search: _vm.search
  }))], 1)]], 2)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }